export const addFiles = (payload?: any) => ({
    type: "@saga/ADD_FILES",
    payload
});

